import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown, faPlus, faSave, faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import './TruckDetails.css'
import { Tooltip } from 'react-tooltip';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import GoCast from '../../Images/GoCast.png'
import { width } from '@fortawesome/free-solid-svg-icons/fa0';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const TruckDetails = () => {

    ////////////Go Back Navigate////////////////

    const GoBack = () => {
        navigate(-1); // Navigates back to the previous page
    };
    ////////////////////////////////////////////

    const [isLoading, setIsLoading] = useState(false); // Loading GIF
    const navigate = useNavigate();
    // Takes Parametres from URL and save it to Variables
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const Key2 = queryParams.get('Key2');
    const Key3 = queryParams.get('Key3');
    const Key4 = queryParams.get('Key4');
    const Key5 = queryParams.get('Key5');
    const Company = queryParams.get('Company');
    // Returns Dynamic Parameter from TruckForm :truckId
    const { truckId } = useParams();
    // Table visibility
    const [tableVisible, setTableVisible] = useState(true);

    // Toggle table visibility
    const toggleTableVisibility = () => {
        setTableVisible(!tableVisible);
    }
    //        API CODE FOR Form
    const [apiData, setApiData] = useState({});
    const [ResourceGRPApiData, setResourceGRPApiData] = useState([]);

    //        API CODE FOR Grid
    const [tableapiData, settableApiData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5); // Adjust this number as needed
    // Add new
    const [showEmptyRow, setShowEmptyRow] = useState(false);
    const [showNewEmptyRow, setShowNewEmptyRow] = useState(false);
    //update fields
    const [TruckId, setTruckid] = useState('');
    const [description, setDescription] = useState('');
    const [PlateNo, setPlateNo] = useState('');
    const [Resourcegroup, setResourcegroup] = useState('');
    const [Driver, setDriver] = useState('');
    const [Helper, setHelper] = useState('');
    const [subcont, setSubCont] = useState(false);
    const [readymix, setReadyMix] = useState(false);

    //update fields 2
    const [Trailerid, setTrailerid] = useState('');
    const [cdescription, setcDescription] = useState('');
    const [warning, setwarning] = useState('');
    const [error, setError] = useState('');
    const [capacity, setCapacity] = useState('');
    const [Volume, setVolume] = useState('');
    const [length, setLength] = useState('');
    const [height, setheight] = useState('');
    const [width, setwidth] = useState('');
    //       UPDATE 
    const [modifiedData, setModifiedData] = useState({});

    const fetchData = async () => {

        setIsLoading(true); // Load GIF

        const username = 'manager'; // Replace with your username
        const password = 'manager'; // Replace with your password
        const apiUrl = `https://77.92.189.102/PPGPrecastVertical/api/v1/Ice.BO.UD102Svc/UD102s(${Company},${truckId},,,,)`; // Adjust the URL as needed
        const api103A = `https://77.92.189.102/PPGPrecastVertical/api/v1/Ice.BO.UD102Svc/UD102As?$filter= Key1 eq '${truckId}'`;

        const apiUrlResourceG = `https://77.92.189.102/PPGPrecastVertical/api/v1/Erp.BO.ResourceGroupSvc/List?$filter= Company eq 'EPIC06'`;

        try {
            console.log("Fetch Data")
            const response = await fetch(apiUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });



            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            setApiData(data); // Set the state with the response object directly

            // Get the drop down data of the Resource Group
            const ResourceGresp = await fetch(apiUrlResourceG, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });

            if (!ResourceGresp.ok) {
                throw new Error('Network response was not ok');
            }
            const ResourceGrData = await ResourceGresp.json();
            setResourceGRPApiData(ResourceGrData.value); // Set the state with the response object directly

            ////////////////////////// Table Grid Data /////////////////////////////////
            const response2 = await fetch(api103A, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Basic ' + btoa(username + ":" + password)
                }
            });
            const data2 = await response2.json();

            if (typeof data2 === 'object' && data2 !== null && Array.isArray(data2.value)) {
                settableApiData(data2.value);
                setIsLoading(false); // Loading GIF

            } else {
                console.error('API response does not contain the expected array in the "value" property:', data2);
            }

        } catch (error) {
            console.error('There was a problem with your fetch operation:', error);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);


    useEffect(() => {
        // Assuming modifiedData is the state holding the checkbox value
        // This effect runs whenever modifiedData changes
        console.log(modifiedData); // Debugging
    }, [modifiedData]);
    const renderTableRows = () => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentItems = tableapiData.slice(startIndex, endIndex);

        return (
            <> {currentItems.map((item, index) => (
                <tr key={index}>
                    <td>{item.ChildKey1}</td>
                    <td>{item.Character01}</td>
                    <td>{item.Number01}</td>
                    <td>{item.Number02}</td>
                    <td>{item.Number03}</td>
                    <td>{item.Number04}</td>
                    <td>{item.Number05}</td>
                    <td>{item.Number06}</td>
                    <td>{item.Number07}</td>
                </tr>
            ))}
                {showNewEmptyRow && (
                    <tr>
                        <td><input type="text" placeholder="Trailer ID" value={Trailerid} onChange={(e) => setTrailerid(e.target.value)} /></td>
                        <td><input type="text" placeholder="Description" value={cdescription} onChange={(e) => setcDescription(e.target.value)} /></td>
                        <td><input type="text" placeholder="Warning %" value={warning} onChange={(e) => setwarning(e.target.value)} /></td>
                        <td><input type="text" placeholder="Error %" value={error} onChange={(e) => setError(e.target.value)} /></td>
                        <td><input type="text" placeholder="Capacity" value={capacity} onChange={(e) => setCapacity(e.target.value)} /></td>
                        <td><input type="text" placeholder="Volume" value={Volume} onChange={(e) => setVolume(e.target.value)} /></td>
                        <td><input type="text" placeholder="Length" value={length} onChange={(e) => setLength(e.target.value)} /></td>
                        <td><input type="text" placeholder="Width" value={width} onChange={(e) => setwidth(e.target.value)} /></td>
                        <td><input type="text" placeholder="Height" value={height} onChange={(e) => setheight(e.target.value)} /></td>
                    </tr>
                )}
            </>

        )
    };

    const goToNextPage = () => {
        const totalPages = Math.ceil(apiData.length / itemsPerPage);
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    //Update 
    const saveData = async () => {
        setIsLoading(true); // Loading GIF
        const username = 'manager';
        const password = 'manager';

        if (showEmptyRow) {
            const apiUrl = `https://77.92.189.102/PPGPrecastVertical/api/v1/Ice.BO.UD102Svc/UD102s`;
            const newRow = {
                "Company": "EPIC06",
                "Key1": TruckId,
                "Character01": description,
                "Character02": PlateNo,
                "Character03": Resourcegroup,
                "Character04": Driver,
                "Character05": Helper,
                "CheckBox01": subcont,
                "CheckBox02": readymix
            };
            console.log("NEW ROW : ", newRow)
            try {
                const response = await axios.post(apiUrl, newRow, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + btoa(username + ":" + password)
                    }
                });
                setShowEmptyRow(false)
                console.log('Data saved successfully:', response.data);
                fetchData();
                // Toast Notifcation
                setTimeout(() => {
                    toast.success("Data Saved Successfully");
                }, 10);
                navigate(`/truck/truckdet/${TruckId}`, { replace: true });

            } catch (error) {
                console.error('Error:', error.message);
                // Toast Notifcation
                setTimeout(() => {
                    toast.success("Failed To Save");
                }, 10);
                setIsLoading(false); // Loading GIF
            }
        }
        else {
            const apiUrl = `https://77.92.189.102/PPGPrecastVertical/api/v1/Ice.BO.UD102Svc/UD102s(${Company},${truckId},,,,)`;

            try {
                const response = await axios.patch(apiUrl, modifiedData, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic ' + btoa(username + ":" + password)
                    }
                });
                console.log('Data saved successfully:', response.data);
                console.log(response.data)
                setIsLoading(false); // Loading GIF
                // Toast Notifcation
                setTimeout(() => {
                    toast.success("Data Saved Successfully");
                }, 10);
            } catch (error) {
                console.error('Error:', error.message);
                // Toast Notifcation
                setTimeout(() => {
                    toast.error("Failed To Save");
                }, 10);
            }
        }
    };

    const handleInputChange = (e, field) => {
        let newValue;
        if (e.target.type === 'checkbox') {
            newValue = e.target.checked;
        } else if (e.target.tagName.toLowerCase() === 'select') {
            // Handle select elements specifically
            newValue = e.target.value;
        } else {
            newValue = e.target.value;
        }
        setModifiedData(prevState => ({
            ...prevState,
            [field]: newValue
        }));
        // If you need to update apiData as well, uncomment the next line
        setApiData(prevState => ({ ...prevState, [field]: newValue }));
    };
    const addNew = () => {
        console.log("Add button clicked!");
        // Reset the modifiedData state to clear all fields
        setModifiedData({});
        settableApiData([]);
        // Optionally, if you want to reset the apiData state as well, uncomment the following line
        setApiData({}); // Uncomment this line if you also want to reset the apiData state
        setShowEmptyRow(true)
    };


    return (
        <div className='card rebartable'>
            <ToastContainer />
            {isLoading && (
                <div className="loading-overlay">
                    <img src={GoCast} alt="Loading..." />
                </div>
            )}
            <div className='TruckForm'>
                <div className="card-header">
                    {/* <button type="button" className="toggle-table-icon" onClick={toggleTableVisibility}>
                        <FontAwesomeIcon icon={tableVisible ? faArrowDown : faArrowUp} />
                    </button> */}
                   <div>
                   <button type="button" className="toggle-table-icon" onClick={GoBack}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                    </button>
                     <h2 className='title-truck px-2'>Truck Detail</h2> 
                   </div>
                    <div className='ctrl-btns-truck-dtl'>
                        {/* Existing buttons */}
                        <button className="btn" id='add' onClick={addNew}>
                            <FontAwesomeIcon icon={faPlus} />
                        </button>
                        <Tooltip
                            anchorSelect="#add"
                            content="Add"
                            place='bottom'
                        />
                        <button className="btn" id='save' onClick={saveData}>
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        <Tooltip
                            anchorSelect="#save"
                            content="Save"
                            place='bottom'
                        />
                    </div>
                </div>
                {/* Conditionally render the table */}
                {tableVisible && (
                    <div className="card-body">
                        <div class="table-responsive">
                            <div className='TruckForm'>
                                <form>
                                    <div class="row row1">
                                        <div class="col-3 leftCol">
                                            <div class="label-input-box-truck">
                                                <input
                                                    type="text"
                                                    id="codeDesc"
                                                    defaultValue={apiData.Key1}
                                                    onChange={(e) => showEmptyRow ? setTruckid(e.target.value) : handleInputChange(e, 'Key1')} 
                                                    placeholder=" "
                                                />
                                                <label htmlFor="codeDesc">Truck ID</label>
                                            </div>
                                            <div class="label-input-box-truck">
                                            <input
                                                    type="text"
                                                    id="codeDesc"
                                                    defaultValue={apiData.Character01}
                                                    onChange={(e) => showEmptyRow ? setDescription(e.target.value) : handleInputChange(e, 'Character01')} 
                                                    placeholder=" "
                                                />
                                            <label htmlFor="codeDesc">Description</label>
                                            </div>
                                            <div class="label-input-box-truck">
                                                <input
                                                    type="text"
                                                    id="codeDesc"
                                                    defaultValue={apiData.Character02}
                                                    onChange={(e) => showEmptyRow ? setPlateNo(e.target.value) : handleInputChange(e, 'Character02')} 
                                                    placeholder=" "
                                                />
                                            <label htmlFor="codeDesc">Plate No</label>
                                            <br/>
                                            </div>
                                            <div class="label-input-box-truckresource">
                                                
                                                <select
                                                    className="Elementidinput-truckdrop"
                                                    id="codeDesc"
                                                    type="text"
                                                    value={apiData.Character03}
                                                    onChange={(e) => handleInputChange(e, 'Character03')}
                                                >
                                                    {ResourceGRPApiData.map((option, index) => (
                                                        <option key={index} value={option.ResourceGrpID}>{option.Description}</option>
                                                    ))}
                                                </select>
                                                <label>Resource Group</label>
                                            </div>
                                        </div>
                                        <div class="col-3 midCol">
                                            <div class="label-input-box-truck">
                                                <input
                                                    type="text"
                                                    id="codeDesc"
                                                    defaultValue={apiData.Character04}
                                                    onChange={(e) => showEmptyRow ? setDriver(e.target.value) : handleInputChange(e, 'Character04')}
                                                    placeholder=" "
                                                />
                                                <label htmlFor="codeDesc">Driver</label>
                                            </div>
                                            <div class="label-input-box-truck">
                                            <input
                                                    type="text"
                                                    id="codeDesc"
                                                    defaultValue={apiData.Character05} 
                                                    onChange={(e) => showEmptyRow ? setHelper(e.target.value) : handleInputChange(e, 'Character05')}
                                                    placeholder=" "
                                                />
                                                <label htmlFor="codeDesc">Helper</label>
                                             </div>
                                        </div>
                                        <div class="col-3 rightColForm">
                                            <div className='loadTypeCont'>
                                                <div className='chkbox-container'>
                                                    <input class="form-check-input " type="checkbox" id="Delivery_Trip1" name='Delivery_Trip' checked={showEmptyRow ? subcont : (apiData.CheckBox01 == undefined ? false : apiData.CheckBox01)} onChange={(e) => showEmptyRow ? setSubCont(e.target.checked) : handleInputChange(e, 'CheckBox01')} />
                                                    <label class="form-check-label-truck " for="Delivery_Trip1">Sub Contract
                                                    </label>
                                                </div>
                                                <div className='chkbox-container'>
                                                    <input class="form-check-input " type="checkbox" id="Delivery_Trip2" name='Delivery_Trip' checked={showEmptyRow ? readymix : (apiData.CheckBox02 == undefined ? false : apiData.CheckBox02)} onChange={(e) => showEmptyRow ? setReadyMix(e.target.checked) : handleInputChange(e, 'CheckBox02')} />
                                                    <label class="form-check-label-truck " for="Delivery_Trip2">Ready Mix
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <div className="card-bodyTruck">
                                    <div class="table-responsive">
                                        <h4 className='panel-title-DT'>Trailer Details</h4>
                                        <table className="table table-bordered">
                                            {/* Table content */}
                                            <thead className='table-primary'>
                                                <tr >
                                                    <th>Trailer ID</th>
                                                    <th>Description</th>
                                                    <th>Warning %</th>
                                                    <th>Error %</th>
                                                    <th>Capacity</th>
                                                    <th>Volume</th>
                                                    <th>Length</th>
                                                    <th>Width</th>
                                                    <th>Height</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {renderTableRows()}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="pagination">
                                        <button onClick={goToPreviousPage} disabled={currentPage === 1}>
                                            <FontAwesomeIcon icon={faArrowLeft} />
                                        </button>
                                        <button onClick={goToNextPage} disabled={currentPage === Math.ceil(apiData.length / itemsPerPage)}>
                                            <FontAwesomeIcon icon={faArrowRight} />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TruckDetails;